export const initialFormState = {
  sku_number: undefined,
  sales_org: undefined,
  country: undefined,
};
